<app-wg-crud-table [title]="config.title" [fields]="config.fields" [service]="service" [showPasswordAction]="true"></app-wg-crud-table>
